<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
      (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" (click)="openDashboard()">
        <img [src]="image_url" alt="" height="30px" width="30px" />
        <span class="logo-name">
          Smart<b>Accu</b>Pay
        </span>
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'">
      <ul class="pull-left collapse-menu-icon">
        <li>
          <button mat-button (click)="callSidemenuCollapse()" class="sidemenu-collapse nav-notification-icons"> <i
            class="material-icons-outlined icon-color">
            menu
          </i></button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right field-h">
        <!-- Custom Triangle Alert Icon -->
        @if (is_show) {
          <li class="alert-icon-container" style="margin: 15px;">
            <div class="icon" [matMenuTriggerFor]="menu">
              <span class="alert-circle"></span>
              <span class="alert-exclamation">!</span>
            </div>
            <!-- Material Menu -->
            <mat-menu #menu="matMenu" class="notification-div">
              <!-- Card for Alert -->
              <div class="alert-message">
                <div class="alert-icon-container">
                  <span class="alert-icon">!</span>
                  <span class="alert-text">Your plan needs payment attention. Click the button below to continue using the
                  system.</span>
                </div>
              </div>
              <div class="row" align="center">
                <button mat-raised-button color="primary" style="width: 150px; margin: auto;"
                (click)="redirectToPayment()" class="payment-button">Go to Payment</button>
              </div>
            </mat-menu>
          </li>
        }
        <!-- Alert for Free Trial Plan -->
        @if (isTrialAlertVisible && is_admin) {
          <li class="alert-icon-container" style="margin: 15px;">
            <div class="icon" [matMenuTriggerFor]="trialMenu">
              <span class="alert-circle"></span>
              <span class="alert-exclamation">!</span>
            </div>
            <!-- Material Menu for Trial Plan Alert -->
            <mat-menu #trialMenu="matMenu" class="notification-div">
              <!-- Card for Trial Alert -->
              <div class="alert-message">
                <div class="alert-icon-container">
                  <span class="alert-icon">!</span>
                  <span class="alert-text">
                    Your free trial is about to expire or has expired. Please subscribe to continue using the system.
                  </span>
                </div>
              </div>
              <div class="row" align="center">
                <button mat-raised-button color="primary" style="width: 150px; margin: auto;" (click)="manageSub()"
                class="payment-button">Choose a Plan</button>
              </div>
            </mat-menu>
          </li>
        }

        @if (onlineLoggedIn && (is_admin === true)) {
          <li>
            <button class="qbo-auth__info-button" (click)="synchronizeQuickbooks()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 379.1919 379.1978">
                <g>
                  <g>
                    <path
                      d="M0,189.5991C0,84.8848,84.8936,0,189.59869,0,294.313,0,379.1919,84.8848,379.1919,189.5991c0,104.7081-84.87891,189.5987-189.59321,189.5987C84.8936,379.1978,0,294.3072,0,189.5991Z"
                      style="fill: #fff" />
                    <path
                      d="M252.8169,115.8745H242.28179v27.3843H252.8169a46.3474,46.3474,0,1,1,0,92.6948H227.50829V92.7031a27.39433,27.39433,0,0,0-27.3911-27.3901V263.3286H252.8169a73.72705,73.72705,0,1,0,0-147.4541ZM52.645,189.5933a73.7257,73.7257,0,0,0,73.7359,73.7246h10.53219v-27.376H126.3809a46.3486,46.3486,0,1,1,0-92.6972h25.31249V286.4986a27.37664,27.37664,0,0,0,27.3877,27.3808V115.8633H126.3809a73.7303,73.7303,0,0,0-73.7359,73.73Z"
                      style="fill: #2da44a" />
                  </g>
                </g>
              </svg>
            </button>
          </li>
        }

        <li class="fullscreen">
          <app-language></app-language>
          <!-- <button mat-button class="nav-notification-icons" (click)="languageSwitcher()"> <i
          class="material-icons-outlined icon-color">
          language
        </i></button> -->
      </li>
      <li>
        <div matTooltip="{{companyCode}}" style="height: 30px; padding-right:10px" (click)="moveToSettings()">
          <img [src]="company_logo" alt="" class="bottom-image-cust" height="35" />
        </div>
      </li>
      <li class="tbl-header-btn dropdown_documenttype">
        <button class="btn success" (click)="switchCompany()">{{companyName}} - {{companyCode}}</button>
      </li>
      <li class="tbl-search-box" style="padding-left:10px">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>{{'COMMON.TOOL_TIP.SEARCH' | translate}}</mat-label>
          <input matInput id="search" class="input-capitalized-textfield" [formControl]="searchControl"
            (input)="onSearchChange($event)">
        </mat-form-field>
        <button aria-label="menu" mat-mini-fab id="global-search" color="primary" [matMenuTriggerFor]="searchMenu"
          style="display: none;" (menuClosed)="menuClosed()">

        </button>
        <mat-menu #searchMenu="matMenu" class="nfc-menu search-div">
          <div class="nfc-header">
            <h5 class="mb-0">Search</h5>
          </div>
          <div class="nfc-dropdown">
            <ng-scrollbar style="height: 350px" visibility="hover">
              <div class="d-flex align-items-center justify-content-center">
                @if (invoiceLoader) {
                  <app-loading></app-loading>
                }
              </div>
              @if (!invoiceLoader) {
                <div>
                  @if (invoiceList.length === 0) {
                    <div class="no-search-data text-center">
                      No Invoice Available
                    </div>
                  }
                  <div class="noti-list header-menu">
                    <div class="menu">
                      <div>
                        @for (invoice of invoiceList; track invoice) {
                          <button mat-menu-item (click)="openInvoiceDetail(invoice)"
                            class="search-button">
                            <div class="row">
                              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 menu-info">
                                <span class="menu-title"><b>Vendor</b> {{invoice.vendor_name}}</span>
                                <span class="menu-title mt-2"><b>Invoice Number</b> {{invoice.invoice_no}}</span>
                              </div>
                              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 menu-info">
                                <span class="menu-title"><b>Amount</b>
                              ${{numberWithCommas(invoice.invoice_total_amount)}} </span>
                              <span class="menu-title mt-2"><b>Status</b> {{invoice.status}}</span>
                            </div>
                            @if (invoice.is_delete === 1) {
                              <div
                                class="col-xs-12 col-sm-12 col-md-6 col-lg-6 menu-info">
                                <span class="menu-title mt-2" style="color: red;"><b>Archived</b></span>
                              </div>
                            }
                          </div>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </ng-scrollbar>
        </div>
      </mat-menu>
    </li>
    <!-- #END# Language Button -->
    <li matTooltip="{{'COMMON.TOOL_TIP.INVOICEMSG' |  translate}}">
      <button mat-button class="nav-notification-icons" (click)="viewMessage()">
        @if (unseenCount !== 0) {
          <mat-icon matBadge="{{unseenCount}}" matBadgeColor="warn">message</mat-icon>
        }
        @if (unseenCount === 0) {
          <mat-icon>message</mat-icon>
        }
      </button>
    </li>
    <!-- #START# Notifications-->
    <li matTooltip="{{'COMMON.TOOL_TIP.NOTIFICATION' |  translate}}">
      <button mat-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons">
        @if (notificationCount !== 0) {
          <mat-icon matBadge="{{notificationCount}}" matBadgeColor="warn" class="material-icons-outlined icon-color"
          >notifications_active</mat-icon>
        }
        @if (notificationCount === 0) {
          <mat-icon>notifications_active</mat-icon>
        }
      </button>

      <mat-menu #notificationMenu="matMenu" class="nfc-menu notification-div">
        <div class="nfc-header">
          <h5 class="mb-0">Notifications</h5>
          <a class="nfc-mark-as-read" (click)="markAllRead()">Mark all as read</a>
        </div>
        <div class="nfc-dropdown" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
          (scrolled)="onScroll()" [scrollWindow]="false" [ngStyle]="setHeightStyles()">
          <div class="d-flex align-items-center justify-content-center">
            @if (notificationLoading) {
              <app-loading></app-loading>
            }
          </div>
          @if (!notificationLoading) {
            <div>
              @if (notificationList.length === 0) {
                <div class="no-search-data text-center">
                  No Notification Available
                </div>
              }
              <div class="noti-list header-menu">
                <div class="menu">
                  <div>
                    @for (notification of notificationList; track notification) {
                      <button mat-menu-item
                        (click)="openNotificationPage(notification)" class="notification-button"
                        [ngClass]="!notification.is_seen ? 'unseen-msg' : ''">
                        <span class="menu-info">
                          <span class="menu-title fw-bold">{{notification.notification_title}}</span>
                          <span class="menu-title mt-2">{{notification.notification_description}}</span>
                          <span class="menu-desc mt-2">
                            <i class="material-icons">access_time</i>
                            {{(notification.created_at * 1000) | date: 'dd MMM, yyyy hh:mm a'}}
                          </span>
                        </span>
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </mat-menu>
    </li>
    <!-- #END# Notifications-->

    <!-- #START# Ticket  -->
    <li class="fullscreen" matTooltip="{{'COMMON.TOOL_TIP.SUPPORT_TICKET' |  translate}}">
      <button mat-button class="nav-notification-icons" (click)="ticketSystem()"> <i
      class="material-icons-outlined icon-color"> assignment_late </i></button>
    </li>
    <!-- #END# Ticket -->
    <li class="nav-item user_profile">
      <button mat-button [matMenuTriggerFor]="profilemenu">
        <div class="chip dropdown-toggle" ngbDropdownToggle class="">
          <span>{{userName}}</span>
          <img src="{{userPicture}}" class="user_img" width="32" height="32" alt="">
        </div>
      </button>
      <mat-menu #profilemenu="matMenu" class="profile-menu">
        <div class="noti-list">
          <div class="menu ">
            <div class="user_dw_menu">
              @if (role_permission.users.View) {
                <button mat-menu-item (click)="goUserProfile()">
                  <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Account
                </button>
              }
              <button (click)="goChangePassword()" mat-menu-item>
                <app-feather-icons [icon]="'key'" [class]="'user-menu-icons'"></app-feather-icons>Change Password
              </button>
              <button (click)="goHelpMenu()" class="dropdown_button" mat-menu-item>
                <app-feather-icons [icon]="'help-circle'" [class]="'user-menu-icons'"></app-feather-icons>
                {{'Help' | translate}}
              </button>
              <button mat-menu-item class="dropdown_button" (click)="generateOTP()">
                <app-feather-icons [icon]="'key'" [class]="'user-menu-icons'"></app-feather-icons>
                {{'Generate OTP' | translate}}
              </button>
              @if (companyList.length > 1) {
                <button mat-menu-item (click)="switchCompany()">
                  <app-feather-icons [icon]="'repeat'" [class]="'user-menu-icons'"></app-feather-icons>Switch
                  Company
                </button>
              }
              @if (role_permission.settings.View) {
                <button mat-menu-item (click)="gotoSettings()">
                  <app-feather-icons [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Settings
                </button>
              }
              <div mat-menu-item class="user-menu__item-title">
                <app-feather-icons [icon]="'sun'" [class]="'user-menu-icons'"></app-feather-icons>
                <app-feather-icons [icon]="'moon'" [class]="'user-menu-icons'"></app-feather-icons>
                <span>
                  <mat-slide-toggle [(ngModel)]="isDarTheme" (ngModelChange)="modelSwitchChange($event)"
                    color="primary">Dark Mode
                    <!-- <mat-slide-toggle [(ngModel)]="isDarTheme" [formControl]="toggleControl" color="primary">Dark Mode -->
                  </mat-slide-toggle>
                </span>
              </div>
              <!-- <button mat-menu-item class="dropdown_button" (click)="generateOTP()">
              <app-feather-icons [icon]="'key'" [class]="'user-menu-icons'"></app-feather-icons>
              Generate OTP
            </button> -->
            <button mat-menu-item (click)="logout()">
              <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>Logout
            </button>
          </div>
        </div>
      </div>
    </mat-menu>
  </li>
  <!-- #END# Tasks -->
</ul>
</div>
</div>
</nav>

@if (showProgress) {
  <div class="progress-overlay">
    <div class="progress-container">
      <div class="progress-circle">
        <svg viewBox="0 0 100 100">
          <circle class="bg" cx="50" cy="50" r="45"></circle>
          <circle class="progress" cx="50" cy="50" r="45" [attr.stroke-dasharray]="282.74"
          [attr.stroke-dashoffset]="282.74 - (progressValue / 100) * 282.74"></circle>
          <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" class="progress-text">
            {{ progressValue | number: '1.0-0' }}%
          </text>
        </svg>
      </div>
      <p class="progress-title">
        Syncing: <strong>{{ getFormattedModuleName(currentModule) }}</strong>
      </p>
      <p class="progress-company-name">
        <span class="label">QuickBooks Company:</span>
        <span class="value" [title]="company_name">{{ company_name
        }}</span>
      </p>
      <p class="progress-message">Sync in progress, please wait...</p>
    </div>
  </div>
}